import * as React from 'react';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import classNames from 'classnames';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import { ProfileDefault } from '../../../../types/uncinc_profile/profile';

import './style.scss';

interface ProfileProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<ProfileDefault>;
  classes: string;
}

const ProfileImage = ({ src, alt }: { src: string[], alt: string; }) => (
  <div className="ProfileTeaser__image ">
    <div className="ProfileTeaser__image__placeholder icon-after icon-search icon-variant-1" />
    <Image
      src={src}
      alt={alt}
    />
  </div>
);

const ProfileTeaser: React.FC<ProfileProps> = ({ entity, classes, ...props }) => {
  const profile = entity.toJS();
  const profileName = profile.field_full_name[0].value;
  const profileFirstName = profileName.split(' ')[0];
  const profileDescription = profile.field_description?.[0]?.processed;
  const profileEmail = profile.field_email_address?.[0]?.value;
  const profileFunction = profile.field_function?.[0]?.entity.name[0].value;
  const imageStyles = profile.field_media_item?.[0]?.styles;
  // #TODO add link once available
  const url = '#';
  const telephone = profile.field_telephone?.[0]?.value;

  const src = [
    `${imageStyles?.ratio_1_1_sm ?? ''}`,
  ];

  return (
    <div className={classNames('ProfileTeaser', classes)} {...props}>

      <div className="ProfileTeaser__imageDesktop">
        <ProfileImage src={src} alt={profileName} />
      </div>

      <div className="ProfileTeaser__description">
        <div className="ProfileTeaser__header">

          <div className="ProfileTeaser__imageMobile">
            <ProfileImage src={src} alt={profileName} />
          </div>

          <div className="ProfileTeaser__nameHeader">
            <div className="ProfileTeaser__nameHeader__name">{profileName}</div>
            <span className="ProfileTeaser__nameHeader__function">{profileFunction}</span>
          </div>
        </div>

        {profileDescription && (
          <div className="ProfileTeaser__content">
            <p>{profileDescription}</p>
          </div>
        )}

        {(telephone || profileEmail || profileDescription) && (
          <div className="ProfileTeaser__links">
            {telephone && <CoreLink to={`tel:${telephone}`}><span className="icon icon-phone" /> {telephone}</CoreLink>}
            {profileEmail && <CoreLink to={`mailto:${profileEmail}`}><span className="icon icon-mail" /> Mail {profileFirstName}</CoreLink>}
            {profileDescription && <CoreLink to={url}><span className="icon icon-comment" />Bio</CoreLink>}
          </div>
        )}

      </div>
    </div>
  );
};

export default ProfileTeaser;

